import React from 'react';
import styled from 'styled-components';
import { blueColor, lightGrey2Color } from 'js/config/style';

export default styled(({ disabled, ...rest }) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 30 23.75" {...rest}>
    <path
      className="share"
      d="M30,9.62l-10.69,9.9V14.63a19.62,19.62,0,0,0-11.6.68,13,13,0,0,0-7.6,8.44c-.52-2.85.83-10,5-13.95C9.06,6,13.93,5,19.26,4.87V0Z"
    />
  </svg>
))`
  position: relative;
  top: -1px;

  .share {
    fill: ${({ disabled }) => (disabled ? lightGrey2Color : blueColor)};
  }
`;
